import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>What Makes A Successful Entrepreneur From The Lens Of A Coach</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>In episode #04, Tekrevol Co-Founder Abeer Raza sits with Michelle Law, a business consultant with over a decade of experience of coaching entrepreneurs discusses the small differences that distinguish struggling entrepreneurs and her 5Ps methodology of making good business decisions. Michelle talks about her experience of working with top CEOs, how they scaled their businesses and what entrepreneurs and small business owners can learn from them to achieve the same level of multi-million dollar growth in their business.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;